module.exports = __webpack_public_path__ + "img/ES0235.883954df.png";